import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetLargeFisheriesQuery,
  usePublicGetLargeFisheriesQuery,
  useGetLargeFisheriesDefaultsQuery,
  usePublicGetLargeFisheriesDefaultsQuery,
  useUpdateLargeFisheriesMutation
} from '../features/modules/largeFisheryApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting large fisheries data based on the current route.
 */
export const useContextAwareGetLargeFisheries = createContextAwareHook(
  useGetLargeFisheriesQuery,
  usePublicGetLargeFisheriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting large fisheries defaults based on the current route.
 */
export const useContextAwareGetLargeFisheriesDefaults = createContextAwareHook(
  useGetLargeFisheriesDefaultsQuery,
  usePublicGetLargeFisheriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateLargeFisheriesMutation
}; 